<template>
  <div class="mobile_server">
    <myHeader />

    <!-- banner模块 -->
    <div class="banner">
      <canvas id="canvasId"></canvas>
      <div class="banner_content">
        <p class="banner_content_p" style="font-size:26px">hecoos Server 媒体服务器</p>
        <p style="font-size: 12px; margin-top: 16px" class="banner_content_p1">
          hecoos
          Server是用来匹配hecoos软件系统的一款功能强大、稳定高效的多媒体服务器
        </p>
        <div class="callMe" @click="jumpTo('/CaseDemonstration#CallMe')">联系我们</div>
      </div>
    </div>

    <!-- 产品模块 -->
    <div class="product" ref="switch_list">
      <div class="tab" id="tab">
        <p style="font-size: 16px; font-weight: 700" class="tab_p">hecoos Server</p>
        <p style="font-size: 26px; font-weight: 700; margin-top: 12px" class="tab_p1">
          包含哪些产品？
        </p>
        <div class="switch">
          <!-- 为每个 span 绑定点击事件和动态类名 -->
          <span :class="{ select: currentTabIndex === 0 }" @click="selectTab(0)">
            Server-D
          </span>
          <span :class="{ select: currentTabIndex === 1 }" @click="selectTab(1)">
            Server-C
          </span>
          <span :class="{ select: currentTabIndex === 2 }" @click="selectTab(2)">
            Server-R
          </span>
          <div class="underline" :style="{
            width: underlineWidth + 'px',
            left: underlineLeft + 'px',
          }"></div>
        </div>
      </div>

      <!-- 产品内容部分 -->
      <div>
        <div class="content">
          <!-- server-D部分 -->
          <div>
            <div class="serverContent" v-show="showContents[0]">
              <div class="text_content">
                <p style="font-size: 14px; margin-bottom: 10px" class="text_content_p">Server-D</p>
                <p style="font-size: 26px; margin-bottom: 10px; font-weight: 700">
                  功能强大&nbsp;&nbsp;<span style="color: #2a82e4">稳定高效</span>
                </p>
                <p style="
                    font-size: 12px;
                    color: #86868b;
                    letter-spacing: 0.5px;
                    line-height: 20px;
                  " class="text_content_p2">
                  hecoos Server –
                  D是匹配hecoos软件系统的一款<span>功能强大、稳定高效</span>的多媒体服务器。其硬件设计契合展演现场严苛执行标准，专为快速部署量身定制。它可在传统舞台播控系统的基础之上实现更加复杂的三维输出，并将视频、灯光、机械等多样舞台设备与元素巧妙融合，统一控制播放，还可在虚拟制作流程中里充当LED
                  屏扩展输出“利器”。内置的
                  hecoos软件系统让预演工程文件与现场执行流畅衔接。 依托
                  hecoos工作流程，最大限度管控从展演的灵感到最终落地呈现的各个环节，<span>从而践行“设计即实现”的产品设计理念，助您打造精彩绝伦的视觉体验。</span>
                </p>
              </div>
              <img style="width: 100%; margin: 20px 0"
                src="https://download.hecoos.com/enlightv/2025-17/9bf5a3c707dd185121045f4da6e76657.png" alt="" />
              <!-- 亮点模块 -->
              <clickSwitch :Info="Info"></clickSwitch>

              <!-- 参数部分 -->
              <div class="text_content">
                <p style="font-size: 14px; margin: 30px 0 10px" class="text_content_p">硬件规格</p>
                <p style="font-size: 26px; font-weight: 700; margin-bottom: 16px">
                  参数细细看
                </p>
                <img style="width: 100%"
                  src="https://download.hecoos.com/enlightv/2025-17/6af24860b3995a3bb2d8bad2e1bf0732.png" alt="" />
              </div>
            </div>
            <div class="parameters" v-show="showContents[0]">
              <div class="parameters_content">
                <p style="font-size: 16px" class="parameters_content_p">规格参数</p>
                <div class="detailed">
                  <p>
                    运行电压: 100-240V，50-60Hz，13 amps冗余电源运行功率:800W
                    @110V<br />(正常)、1000W @ 110V(最大)<br />
                    机箱规格:4U 19”英寸机架操作系统:Windows 10 Pro <br />
                    CPU处理器:英特尔 至强 Gold 6226R 处理器(16核32线程)<br />
                    系统内存:64G RDIMM DDR4内存 (32G x 2)<br />
                    单台系统显存要求:16G <br />
                    单台支持贴图像素点:1920*1080*16<br />
                    Artnet:支持 <br />
                    系统硬盘:2TB SSD<br />
                    最大SSD硬盘数量:4<br />
                    支持物理上级联扩展模式，扩展模式不受数量限制支持Optitrack红外追踪系统<br />
                    具备背板照明 <br />
                    具备PCI-E扩展连接器<br />
                    网络接口:1xGB LAN ，10XGB LAN<br />
                    具备OLED状态文本显示(详细描述)<br />
                    机箱宽高深(mm):430(宽)*178(高)*634(深)
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p style="font-size: 16px; display: inline-block" class="parameters_content_p">
                  工作环境容限
                </p>
                <div class="detailed">
                  <p>
                    温度:5-35°C(40°-95°) <br />
                    湿度:5%-95%(non-condensing) <br />
                    海拔高度:0-8850ft(0-2700m)<br />
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p style="font-size: 16px; display: inline-block" class="parameters_content_p">I/O规格</p>
                <div class="detailed">
                  <div class="test">
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        视频输出<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2<br />
                          独立输出通道最大分辨率(4096x2160)</span><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        视频输入<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2 <br />
                          独立输出通道最大分辨率(4096x2160)</span><br />
                      </p>
                    </div>
                  </div>
                  <div class="test">
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        数据/外设<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2<br />
                          独立输出通道最大分辨率(4096x2160)</span><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        音视频输入/输出<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2<br />
                          独立输出通道最大分辨率(4096x2160)</span><br />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="parameters_content">
                <div class="detailed_box">
                  <p style="font-size: 16px" class="parameters_content_p">原厂配件</p>
                  <p style="margin-left: 80px">
                    机械键盘鼠标 <br />
                    800W铂金电源 <br />
                    环出线<br />
                    DP转DVI转接线 x6SM <br />
                    DP线 x4
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <div class="detailed_box">
                  <p style="font-size: 16px" class="parameters_content_p">售后保障</p>
                  <p style="margin-left: 80px">
                    软件终身免费 <br />
                    使用及升级服务器 <br />
                    硬件两年保修免费 <br />
                    远程技术支持
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- server-C部分 -->
          <div>
            <div class="serverContent" v-show="showContents[1]">
              <div class="text_content">
                <p style="font-size: 14px; margin-bottom: 10px" class="text_content_p">Server-C</p>
                <p style="font-size: 26px; font-weight: 700; margin-bottom: 10px">
                  虚拟现实&nbsp;&nbsp;<span style="color: #2a82e4">精准契合</span>
                </p>
                <p style="
                    font-size: 12px;
                    color: #86868b;
                    line-height: 20px;
                    letter-spacing: 0.5px;
                  " class="text_content_p2">
                  一款专为虚拟制作领域设计的多媒体服务器，作为虚拟制作拍摄流程中的<span>“核心枢纽”</span>，
                  xR – C
                  多媒体服务器可以和追踪系统协作，依据追踪信息（例如演员的位置、摄像机的运动轨迹）迅速调度实时渲染引擎，灵活改变渲染画面的场景视角，确保虚拟和现实<span>元素精准契合</span>。搭配灯光系统时，它能根据场景氛围和光照需求，实时调整虚拟物体的光影效果，从而提升成片的视觉感受。xR
                  –
                  C以其灵活的扩展性、优异的稳定性与丰富的I/O接口为拍摄现场提供坚实保障，不仅如此，它还可以<span>根据现场实际需求进行专业定制化配置，是您进行虚拟制作工作的必要选择。</span>
                </p>
              </div>
              <img style="width: 100%; margin: 20px 0"
                src="https://download.hecoos.com/enlightv/2025-17/58ba9ed9b9f7b2f7e2a0b221d3438db8.png" alt="" />
              <!-- 亮点模块 -->
              <clickSwitch :Info="Info"></clickSwitch>
              <!-- 参数部分 -->

              <div class="text_content">
                <p style="font-size: 14px; margin: 30px 0 10px" class="parameters_content_p">硬件规格</p>
                <p style="font-size: 26px; font-weight: 700; margin-bottom: 16px">
                  参数细细看
                </p>
                <img style="width: 100%"
                  src="https://download.hecoos.com/enlightv/2025-17/6af24860b3995a3bb2d8bad2e1bf0732.png" alt="" />
              </div>
            </div>
            <div class="parameters" v-show="showContents[1]">
              <div class="parameters_content">
                <p style="font-size: 16px; display: inline-block" class="parameters_content_p">规格参数</p>
                <div class="detailed">
                  <p>
                    CPU处理器:英特尔 至强 Gold 6226R 处理器(16核32线程)<br />
                    主板:定制主板 <br />
                    系统内存:64G RDIMM DDR4内存 (32G x 2) <br />
                    硬盘1:M.2 NVMe SSD 2TB系统盘 <br />
                    硬盘2:U.2 NVMe SSD数据盘 4TB<br />
                    风扇型号:定制散热风扇 <br />
                    机箱型号:定制机箱 <br />
                    显卡：A5000 24GB GDDR6<br />
                    同步卡：NVIDIA 二代同步卡 <br />
                    采集卡：BMD-8k pro<br />
                    BMC卡:远程网络管理 <br />
                    网卡1：1Gb RJ45 <br />
                    网卡2：Mellanox 迈络思100Gb<br />
                    光口 多屏卡背板：定制多屏卡背板<br />
                    多屏卡主板：定制多屏卡主板DP/DVI
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p style="font-size: 16px; display: inline-block" class="parameters_content_p">
                  工作环境容限
                </p>
                <div class="detailed">
                  <p>
                    温度:5-35°C(40°-95°) <br />
                    湿度:5%-95%(non-condensing) <br />
                    海拔高度:0-8850ft(0-2700m)<br />
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p style="font-size: 16px; display: inline-block" class="parameters_content_p">I/O规格</p>
                <div class="detailed">
                  <div class="test">
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        视频输出<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2<br />
                          独立输出通道最大分辨率(4096x2160)</span><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        视频输入<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2 <br />
                          独立输出通道最大分辨率(4096x2160)</span><br />
                      </p>
                    </div>
                  </div>
                  <div class="test">
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        数据/外设<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2<br />
                          独立输出通道最大分辨率(4096x2160)</span><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        音视频输入/输出<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2<br />
                          独立输出通道最大分辨率(4096x2160)</span><br />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="parameters_content">
                <div class="detailed_box">
                  <p style="font-size: 16px">原厂配件</p>
                  <p style="margin-left: 80px">
                    机械键盘鼠标 <br />
                    800W铂金电源 <br />
                    环出线<br />
                    DP转DVI转接线 x6SM <br />
                    DP线 x4
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <div class="detailed_box">
                  <p style="font-size: 16px">售后保障</p>
                  <p style="margin-left: 80px">
                    软件终身免费 <br />
                    使用及升级服务器 <br />
                    硬件两年保修免费 <br />
                    远程技术支持
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- server-R部分 -->
          <div>
            <div class="serverContent" v-show="showContents[2]">
              <div class="text_content">
                <p style="font-size: 14px; margin-bottom: 10px" class="text_content_p">Server-R</p>
                <p style="font-size: 26px; font-weight: 700; margin-bottom: 10px">
                  自由选择&nbsp;&nbsp;<span style="color: #2a82e4">灵活调配</span>
                </p>
                <p style="
                    font-size: 12px;
                    color: #86868b;
                    line-height: 20px;
                    letter-spacing: 0.5px;
                  " class="text_content_p2">
                  hecoos Server xR –
                  R媒体服务器作为<span>强大的引擎载体</span>，将UnrealEngine/Notch/Unity3D等实时渲染引擎所生产的三维虚拟场景融入拍摄流程之中。融入<span>SMPTEST2110标准</span>的100G传输带宽，呈现低延迟、高质量逼真视效。其兼容性出色，不局限于特定引擎，创作者可自由选择多种引擎配合完成同一场景的生产，灵活调配。面对繁重复杂的实时场景渲染任务时，多台xR
                  –R渲染节点配合工作，借助集群渲染轻松驾驭超高品质的画面输出，<span>高效处理高负载工作</span>。加之实时光线追踪及引擎反向控制等丰富功能，为虚拟内容创作者提供贴心保障。
                </p>
              </div>
              <img style="width: 100%; margin: 20px 0"
                src="https://download.hecoos.com/enlightv/2025-17/93682b68b9c7f106bf40939e1059af7a.png" alt="" />
              <!-- 亮点模块 -->
              <clickSwitch :Info="Info"></clickSwitch>

              <!-- 参数部分 -->

              <div class="text_content">
                <p style="font-size: 14px; margin: 30px 0 10px" class="text_content_p">硬件规格</p>
                <p style="font-size: 26px; font-weight: 700; margin-bottom: 16px">
                  参数细细看
                </p>
                <img style="width: 100%"
                  src="https://download.hecoos.com/enlightv/2025-17/6af24860b3995a3bb2d8bad2e1bf0732.png" alt="" />
              </div>
            </div>
            <div class="parameters" v-show="showContents[2]">
              <div class="parameters_content">
                <p style="font-size: 16px; display: inline-block" class="parameters_content_p">规格参数</p>
                <div class="detailed">
                  <p>
                    CPU处理器:英特尔 酷睿Ultra 9 处理器 285K<br />
                    主板：华硕Z890系列主板 <br />
                    系统内存:64G DDR5内存 <br />
                    硬盘1:M.2 NVMe<br />
                    SSD 2T系统盘 <br />
                    风扇型号:定制散热风扇 <br />
                    机箱型号:通用版机箱<br />
                    系统硬盘:2TB SSD <br />
                    最大SSD硬盘数量:4<br />
                    支持物理上级联扩展模式，扩展模式不受数量限制支持Optitrack红外追踪系统<br />
                    具备背板照明 <br />
                    具备PCI-E扩展连接器 <br />
                    网络接口:1xGB LAN ，10XGB LAN<br />
                    具备OLED状态文本显示(详细描述)<br />
                    机箱宽高深(mm):430(宽)*178(高)*634(深)
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p style="font-size: 16px; display: inline-block" class="parameters_content_p">
                  工作环境容限
                </p>
                <div class="detailed">
                  <p>
                    温度:5-35°C(40°-95°) <br />
                    湿度:5%-95%(non-condensing) <br />
                    海拔高度:0-8850ft(0-2700m)<br />
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p style="font-size: 16px; display: inline-block" class="parameters_content_p">I/O规格</p>
                <div class="detailed">
                  <div class="test">
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        视频输出<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2<br />
                          独立输出通道最大分辨率(4096x2160)</span><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        视频输入<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2 <br />
                          独立输出通道最大分辨率(4096x2160)</span><br />
                      </p>
                    </div>
                  </div>
                  <div class="test">
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        数据/外设<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2<br />
                          独立输出通道最大分辨率(4096x2160)</span><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p style="font-size: 14px">
                        音视频输入/输出<br />
                        <span style="color: #a6a6a6; font-size: 12px">6 x DisplayPort 1.2<br />
                          独立输出通道最大分辨率(4096x2160)</span><br />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="parameters_content">
                <div class="detailed_box">
                  <p style="font-size: 16px" class="parameters_content_p">原厂配件</p>
                  <p style="margin-left: 80px;">
                    机械键盘鼠标 <br />
                    800W铂金电源 <br />
                    环出线<br />
                    DP转DVI转接线 x6SM <br />
                    DP线 x4
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <div class="detailed_box">
                  <p style="font-size: 16px" class="parameters_content_p">售后保障</p>
                  <p style="margin-left: 80px;">
                    软件终身免费 <br />
                    使用及升级服务器 <br />
                    硬件两年保修免费 <br />
                    远程技术支持
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <myListen :listenList="listenList" v-if="showContents[0]" />
    <myInquire />
    <myFooter />
  </div>
</template>

<script>
import myHeader from "@/components/mobile/myHeader.vue";
import myFooter from "@/components/mobile/myFooter.vue";
import myListen from "@/components/mobile/myListen.vue";
import myInquire from "@/components/mobile/myInquire.vue";
import clickSwitch from "@/components/mobile/clickSwitch.vue";
import { initThreeNoiseEffect } from '@/utils/threeNoiseEffect.js';
export default {
  data() {
    return {
      // 新增变量，用于记录当前选中的 tab 索引
      currentTabIndex: 0,
      underlineWidth: 0,
      underlineLeft: 0,
      // 新增数组，用于控制每个产品内容的显示状态
      showContents: [true, false, false, false],
      tabInfo: {
        server_D: [
          {
            id: "001",
            title: "内容播放",
            msg: "强大的非编渲染引擎，实时高性能2D/3D图形渲染，支持OpenGL、DirectX，支持格式覆盖目前几乎所有视频格式，包括序列帧在内的三十多种视频编码（HAP、HVC等）均可流畅播放。",
            url: 'https://download.hecoos.com/enlightv/2025-17/fae918c5d4a93841bc4769f8c4568c8b.png',
          },
          {
            id: "002",
            title: "画面映射",
            msg: "hecoos可根据创意需求直接将视频画面通过平行投射、球形投射、透视投射、柱形投射等画面映射（Mapping）方式映射到显示介质上，轻松实现3D Mapping及xR背景显示。",
            url: 'https://download.hecoos.com/enlightv/2025-17/a6c324978b81ed0e5dc01b3db014ee17.png',
          },
          {
            id: "003",
            title: "多屏幕延展",
            msg: "无限分辨率的视频与图像解码能力，匹配服务器多级级联系统工作架构，可实现对任意分辨率、任意数量的LED显示屏、投影的点对点流畅播放。",
            url: 'https://download.hecoos.com/enlightv/2025-37/58a8c128d1bacd451c09589dc9273168.png',
          },
          {
            id: "004",
            title: "3DMapping",
            msg: "支持 3D 模型导入，可以根据 UV 的展开方式将视频贴合到模型表面，同时可以在三维空间内进行预演和观看。基于三维模型展UV或透视投射原理产生影像内容，通过投影实时反算的方式将内容mapping到真实模型上完成画面输出。",
            url: 'https://download.hecoos.com/enlightv/2025-17/896f2237bace53a89cbaa2bc7804040a.png',
          },
          {
            id: "005",
            title: "灵活扩展I/O",
            msg: "通过接入Arduino套件或直接接入雷达、编码器、控制器等设备，以连接更丰富的输入与输出环境。可直接对接伺服电机、舵机、步进电机等机械设备，为项目实现提供更多可选项。",
            url: 'https://download.hecoos.com/enlightv/2025-17/96115941405a2a888c8e3bde5c6ad839.png',
          },
          {
            id: "006",
            title: "追踪系统接入",
            msg: "追踪系统数据接入（VICON、blacktrax、optitrack、sInfo、Mo-sys、Redspy等）传感器接入（Radar、红外、压感、kinnect等）开源硬件对接（ARDUINO、树莓派等）",
            url: 'https://download.hecoos.com/enlightv/2025-17/d9fac1b1240180c181999e676c3d6d53.png',
          },
        ],
        server_C: [
          {
            id: "001",
            title: "镜头测量与定位",
            msg: "强大的非编渲染引擎，实时高性能2D/3D图形渲染，支持OpenGL、DirectX，支持格式覆盖目前几乎所有视频格式，包括序列帧在内的三十多种视频编码（HAP、HVC等）均可流畅播放。",
            url: 'https://download.hecoos.com/enlightv/2025-17/37f549101ac217def309cf249ff30e36.png',
          },
          {
            id: "002",
            title: "延迟校准",
            msg: "hecoos可根据创意需求直接将视频画面通过平行投射、球形投射、透视投射、柱形投射等画面映射（Mapping）方式映射到显示介质上，轻松实现3D Mapping及xR背景显示。",
            url: 'https://download.hecoos.com/enlightv/2025-17/bfadae3a04c9937fddfdbedf990bc4c8.png',
          },
          {
            id: "003",
            title: "色彩校准",
            msg: "无限分辨率的视频与图像解码能力，匹配服务器多级级联系统工作架构，可实现对任意分辨率、任意数量的LED显示屏、投影的点对点流畅播放。",
            url: 'https://download.hecoos.com/enlightv/2025-17/7e6c8a04ff7f81a12ff5bca98b38bbb2.png',
          },
          {
            id: "004",
            title: "多机位切换",
            msg: "支持 3D 模型导入，可以根据 UV 的展开方式将视频贴合到模型表面，同时可以在三维空间内进行预演和观看。基于三维模型展UV或透视投射原理产生影像内容，通过投影实时反算的方式将内容mapping到真实模型上完成画面输出。",
            url: 'https://download.hecoos.com/enlightv/2025-17/ccac8c851186e55acae1dc6ac1d105f7.png',
          },
          {
            id: "005",
            title: "引擎关卡/序列管理",
            msg: "通过接入Arduino套件或直接接入雷达、编码器、控制器等设备，以连接更丰富的输入与输出环境。可直接对接伺服电机、舵机、步进电机等机械设备，为项目实现提供更多可选项。",
            url: 'https://download.hecoos.com/enlightv/2025-17/23207610ab5776b51566e965a4053b44.png',
          },
          {
            id: "006",
            title: "虚拟与现实灯光联调控制",
            msg: "追踪系统数据接入（VICON、blacktrax、optitrack、sInfo、Mo-sys、Redspy等）传感器接入（Radar、红外、压感、kinnect等）开源硬件对接（ARDUINO、树莓派等）",
            url: 'https://download.hecoos.com/enlightv/2025-17/2f2ac00a4b671a5b47513b91bff11a2b.png',
          },
        ],
        server_R: [
          {
            id: "001",
            title: "Rivermax集群渲染",
            msg: "内视锥渲染画面与集群中的其他渲染节点共享，避免各节点的渲染资源浪费，多节点合理分工使画面质量更高、更流畅。使用SMPTE 2110 同步策略对每个渲染节点进行帧锁定，确保虚幻引擎输出与摄影机保持同步。",
            url: 'https://download.hecoos.com/enlightv/2025-35/f64b3aac4995550b7bdbd48ce58440b1.png ',
          },
          {
            id: "002",
            title: "引擎选择",
            msg: "作为强大的引擎载体，hecoos将Unreal Engine/Notch/Unity 3D/TouchDesigner/Proceesing等实时渲染引擎所生产的视觉内容融入播放与虚拟拍摄流程之中。创作者无需局限于特定引擎，自由选择内容工具完成作品。",
            url: 'https://download.hecoos.com/enlightv/2025-17/1e162cde5a14bffd1123ac5213c9fc89.png',
          },
          {
            id: "003",
            title: "引擎反向控制",
            msg: "虚拟拍摄流程中可通过hecoos反向编辑实时渲染引擎的设置，拍摄现场灵活调整资产细节，使拍摄过程更加顺滑。",
            url: 'https://download.hecoos.com/enlightv/2025-17/08d68581ca1058f33b9fe8494e3f5cf0.png',
          },
        ],
      },
      Info: [],
      listenList: [
        {
          msg: "在过去的创作中，构思与实际呈现常有偏差，许多想法难以达成。与 hecoos 的配合改变了这个状况，模拟预演的流程使我的团队能够提前预见作品效果，可以及时调整优化。很多种三维映射方案确保最终作品呈现和预期是一致的，不用再因技术局限而妥协作品标准，对于创作团队而言，是非常难得的。",
          author: "邓博    飞扬萝卜  CEO&制作人",
        },
      ],
    };
  },
  created() {
    const section = this.$route.query.section;
    // console.log(section,'section');
    if (section >= 0 && section <= 2) {
      this.selectTab(section);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updateUnderlinePosition();
      this.setupSpanResizeObservers();
      window.addEventListener("resize", this.updateUnderlinePosition);
    });
    initThreeNoiseEffect('canvasId');
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateUnderlinePosition);
  },
  methods: {
    // 新增方法，用于处理 tab 切换
    selectTab(index) {
      // console.log('1111110',index);

      this.currentTabIndex = index;
      this.updateUnderlinePosition();
      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[index] = true;
      if (index === 1) {
        this.Info = this.tabInfo.server_C;
        // console.log(this.Info);
      } else if (index === 2) {
        this.Info = this.tabInfo.server_R;
        // console.log(this.Info);
      } else {
        this.Info = this.tabInfo.server_D;
        // console.log(this.Info);
      }
      // 将index存储到本地
      // localStorage.setItem("tabIndex", index);
    },
    // 导航切换底部跟随
    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("span")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        // 计算去除 padding 后的左侧偏移量
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },
     jumpTo(url) {
      this.$router.push(url);
    },
    // 文字宽度变化监听
    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("span");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },
  },
  beforeMount() {
    this.Info = this.tabInfo.server_D;
    // console.log(this.Info);

  },
  components: {
    myHeader,
    myFooter,
    myListen,
    myInquire,
    clickSwitch,
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mobile_xty.scss";
.callMe {
      width: 80px;
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
      background-color: #2a82e4;
      margin: 0 auto;
      margin-top: 20px;
      font-size: 12px;
      transition: 0.3s ease;
      cursor: pointer;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #2a82e4;
    }
     @media screen and (min-width: 768px) {
      .callMe {
      width: 180px;
      height: 50px;
      line-height: 50px;
      border-radius: 30px;
      background-color: #2a82e4;
      margin: 0 auto;
      margin-top: 20px;
      font-size: 18px;
      transition: 0.3s ease;
      cursor: pointer;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #2a82e4;
    }
    }
</style>
